import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-arrow-clockwise"
}
const _hoisted_2 = { class: "au-card" }
const _hoisted_3 = { class: "au-card-head" }
const _hoisted_4 = { class: "au-card-title" }
const _hoisted_5 = { class: "au-search ms-auto" }
const _hoisted_6 = ["placeholder", "aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "au-empty"
}
const _hoisted_8 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_9 = { class: "visually-hidden" }
const _hoisted_10 = {
  key: 1,
  class: "au-empty"
}
const _hoisted_11 = { class: "au-empty-title" }
const _hoisted_12 = {
  key: 2,
  class: "au-empty"
}
const _hoisted_13 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_14 = { class: "table table-hover" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "au-entity" }
const _hoisted_17 = { style: {"min-width":"0"} }
const _hoisted_18 = { class: "au-entity-name" }
const _hoisted_19 = { class: "au-entity-sub" }
const _hoisted_20 = { class: "au-actions" }
const _hoisted_21 = {
  key: 4,
  class: "au-card-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_page_header = _resolveComponent("bs5-page-header")!
  const _component_bs5_icon_button = _resolveComponent("bs5-icon-button")!
  const _component_EditDistributorModal = _resolveComponent("EditDistributorModal")!
  const _component_AddDistributorModal = _resolveComponent("AddDistributorModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_bs5_page_header, {
      title: _ctx.$t('distributors.title'),
      subtitle: _ctx.$t('distributors.subtitle')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_bs5_base_button, {
          variant: "secondary",
          loading: _ctx.loading,
          onClick: _ctx.fetchDistributors
        }, {
          default: _withCtx(() => [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t("common.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_bs5_base_button, {
          variant: "primary",
          onClick: _ctx.openAddDistributorModal
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t("distributors.new")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-shop" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t("distributors.list")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            class: "form-control",
            placeholder: _ctx.$t('distributors.search'),
            "aria-label": _ctx.$t('distributors.search')
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.search]
          ])
        ])
      ]),
      (_ctx.loading && _ctx.distributors.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("common.loading")), 1)
            ])
          ]))
        : (_ctx.distributors.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-shop" }, null, -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("distributors.emptyTitle")), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("distributors.emptyText")), 1)
            ]))
          : (_ctx.filteredDistributors.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("distributors.noResults")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-shop me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("distributors.distributor")), 1)
                      ]),
                      _createElementVNode("th", _hoisted_15, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-lightning-charge me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t("common.actions")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDistributors, (distributor) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: distributor.id as string
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "au-avatar" }, [
                              _createElementVNode("i", { class: "bi bi-shop" })
                            ], -1)),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(distributor.name), 1),
                              _createElementVNode("div", _hoisted_19, [
                                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-chat-left-text" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(distributor.description || _ctx.$t("distributors.noDescription")), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-pencil",
                              label: _ctx.$t('common.edit'),
                              onClick: ($event: any) => (_ctx.openEditDistributorModal(distributor.id as string))
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_bs5_icon_button, {
                              icon: "bi-trash3",
                              tone: "danger",
                              label: _ctx.$t('common.delete'),
                              onClick: ($event: any) => (_ctx.deleteDistributor(distributor))
                            }, null, 8, ["label", "onClick"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])),
      (_ctx.distributors.length > 0 && _ctx.filteredDistributors.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("distributors.total", { count: _ctx.filteredDistributors.length })), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_EditDistributorModal, {
      visible: _ctx.showEditDistributorModal,
      distributorId: _ctx.selectedDistributorId as string,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditDistributorModal = false)),
      onDistributorUpdated: _ctx.fetchDistributors
    }, null, 8, ["visible", "distributorId", "onDistributorUpdated"]),
    _createVNode(_component_AddDistributorModal, {
      visible: _ctx.showAddDistributorModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddDistributorModal = false)),
      onDistributorAdded: _ctx.fetchDistributors
    }, null, 8, ["visible", "onDistributorAdded"])
  ]))
}